<template>
  <div class="main-layout worker-edit-page">
    <el-card shadow="never" class="box-outter box-outter-back">
      <c-title slot="header" :title="title"></c-title>
      <div class="div-scroll" style="padding: 20px 20%">
        <c-form
          v-model="handleData"
          ref="cForm"
          :formItems="formItems"
          :formRules="formRules"
          labelWidth="120px"
          :disabled="true"
        >
          <div slot="custom" style="margin-bottom: 18px">
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column
                label="序号"
                align="center"
                type="index"
                width="50"
              ></el-table-column>
              <el-table-column
                label="测试选项"
                align="center"
                prop="optionName"
              >
              </el-table-column>
              <el-table-column label="分数" align="center" prop="score">
              </el-table-column>
            </el-table>
          </div>
        </c-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import MHandle from "@/mixins/MHandle.js";
import Configs from "./data/question";
let mHandle = MHandle({
  handleGetPath: "/welcome-forecast/test/title",
  handleInsertPath: "/welcome-forecast/test/title/save",
  handleUpdatePath: "/welcome-forecast/test/title/update",
  handleDownLoadPath: "",
  handleData: {
    name: "",
    dimension: "",
  },
});
export default {
  mixins: [mHandle],
  data() {
    let { formItems, formRules } = Configs(this);
    return {
      formItems,
      formRules,
      title: "",
      tableData: [],
      SUCCESS_CODE: "",
    };
  },
  created() {},
  mounted() {
    this.title = "测试题目详情";
    let id = (this.handleData.id = this.$route.params.id);
    this.handleGet(id);
  },
  methods: {
    handleGetAfterFn(data) {
      this.tableData = data.options;
    },
  },
  beforeDestroy() {},
};
</script>

